import React, { useEffect } from 'react';
import { Card } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';
import InlineFile from '../../../common/inline/InlineFile';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateSupplier } from '../Supplier.hooks';
import { BaseSupplierCardProps } from '../Supplier.interface';

const SupplierFileAttachmentCard: React.FC<BaseSupplierCardProps> = (
  props: BaseSupplierCardProps
) => {
  const {
    supplier,
    supplierVersion,
    token,
    onChange,
    onUpdate,
    onError
  } = props;
  const {
    updatedSupplier,
    isUpdating,
    updateError,
    updateSupplier
  } = useUpdateSupplier(supplier.id, token);
  const disabled = !!supplierVersion;
  const initialData = supplierVersion || supplier;
  const { isFieldDisabled } = useTaskEntityFields<WorkflowEntity.Supplier>(
    supplier.task,
    { token }
  );

  useEffect(() => {
    if (updatedSupplier) {
      onChange?.(updatedSupplier);
      onUpdate?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedSupplier]);

  useEffect(() => {
    if (updateError) {
      onError?.(updateError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateError]);

  return (
    <Card>
      <CardTitle>
        <AttachFileIcon />
        File Attachments
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          isSubmitting={isUpdating}
          initialValues={{ attachments: initialData.attachments || [] }}
          onSubmit={(supplierDto: Partial<any>) => {
            console.log('supplierDto', supplierDto);
            updateSupplier(supplierDto);
            onChange?.(supplierDto);
          }}
        >
          {() => (
            <InlineForm>
              <InlineFile
                multiple
                token={token}
                name='attachments'
                uploadPath='attachments'
                label='Attach any relevant documents for review.'
                // Accept all file types
                // inputType={InputAcceptType.Documents}
                disabled={disabled || isFieldDisabled('attachments')}
              />
            </InlineForm>
          )}
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default SupplierFileAttachmentCard;
